import { gql } from '@apollo/client';

export default gql`
  query GetFlatExperience($id: ID! = "", $slug: String! = "") {
    flatExperienceGroup(id: $id) {
      data {
        attributes {
          flat_experiences(filters: { slug: { eq: $slug } }) {
            data {
              attributes {
                title
                description_ck
                slug
                disableBookmarking
                image {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                carouselPosition
                image_carousel {
                  data {
                    attributes {
                      carouselItems(pagination: { limit: 30 }) {
                        image {
                          data {
                            attributes {
                              url
                            }
                          }
                        }
                      }
                    }
                  }
                }
                keywords {
                  data {
                    attributes {
                      keyword
                    }
                  }
                }
                bookmarkLinks {
                  label
                  externalUrl
                }
              }
            }
          }
        }
      }
    }
  }
`;
